<div layout="row" [style.display]="state.value === 'inactive' ? 'none' : ''">
  <div flex="95">
    <div *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title">
      {{ title }}
    </div>
    <div
      *ngIf="message && options.enableHtml"
      role="alert"
      aria-live="polite"
      [class]="options.messageClass"
      [innerHTML]="message"
    ></div>
    <div
      *ngIf="message && !options.enableHtml"
      role="alert"
      aria-live="polite"
      [class]="options.messageClass"
      [attr.aria-label]="message"
    >
      {{ message }}
    </div>
  </div>
  <div flex class="text-right">
    <a *ngIf="!options.closeButton" class="btn btn-nib btn-sm" (click)="action($event)">
      {{ actionString }}
    </a>
    <a *ngIf="options.closeButton" (click)="remove()" class="btn btn-nib btn-sm"> close </a>
  </div>
</div>
<div *ngIf="options.progressBar">
  <div class="toast-progress" [style.width]="width + '%'"></div>
</div>
